import { createStore } from '@stencil/store';
import { RenderTree } from './render.types';

const initialState: RenderTree = new RenderTree();

const { state, reset,onChange } = createStore(initialState);

export const renderStore = {
  state,
  reset,
  onChange,
  updateComponentsById: (id:string,val: ComponentItem[]) => {
    state.instanceTree[id] = val
  },
};
